import { Directive, inject, Signal } from '@angular/core';
import { ResponsiveService } from '../services/reponsive.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Directive({
  standalone: true,
  selector: '[appPage]',
  host: {
    '[class.smallScreen]': 'smallScreen()',
    '[class.mediumScreen]': 'mediumScreen()',
    '[class.largeScreen]': 'largeScreen()',
  },
})
export class PageDirective {
  private readonly responsiveService: ResponsiveService =
    inject(ResponsiveService);

  readonly smallScreen: Signal<boolean> = toSignal(
    this.responsiveService.small$,
    {
      initialValue: false,
    },
  );
  readonly mediumScreen: Signal<boolean> = toSignal(
    this.responsiveService.desktop$,
    {
      initialValue: false,
    },
  );
  readonly largeScreen: Signal<boolean> = toSignal(
    this.responsiveService.largeDesktop$,
    { initialValue: false },
  );
}
